export enum OvertimeStatus {
  Rejected,
  Approved,
  Dispute,
  Pending
}